<template>
  <v-col
    v-if="
      checkActionsProducts !== 0 && hasProductsMultipleTypeIds && formuleType
    "
    cols="12"
    md="6"
  >
    <select-field-with-title
      v-model="selectedTypeFormule"
      label="Faites votre choix"
      :items="formuleType"
      :itemTitle="'title'"
      :itemValue="'value'"
      :chips="true"
      :closableChips="true"
      :multiple="true"
      :hide-details="true"
      variant="underlined"
    ></select-field-with-title>
  </v-col>
  <div v-if="showInscriptionCard" class="products">
    <module-inscription-card
      v-for="(product, key) in filteredProducts"
      :key="`${key}-${refreshKey}`"
      class="my-4"
      :product="product"
      v-model:selected-product-value="selectedProduct"
      :periodCaptions="periodCaptions"
      :selectedChild="selectedChild"
      :selected-year="selectedYear"
    />
  </div>
  <v-row v-if="checkActionsProducts == 0" justify="center" class="px-3 mt-13">
    <span class="font-weight-medium">
      Aucune formation programmée correspondant à ces critères.<br />
      Vous pouvez nous joindre au
      <span class="font-weight-bold phone-number"> 01 42 05 41 36 </span> pour
      plus de précisions.
    </span>
  </v-row>
</template>

<script>
import ModuleInscriptionCard from "@/components/module-inscription/ModuleInscriptionCard.vue";
import { getFormuleTypeLabel } from "@/constants/formule-type";
import SelectFieldWithTitle from "@/components/form-base/SelectFieldWithTitleBase.vue";

export default {
  components: {
    SelectFieldWithTitle,
    ModuleInscriptionCard,
  },

  props: {
    products: {
      type: Array,
      required: true,
    },
    selectedChild: {
      type: Object,
      default: null,
    },
    selectedYear: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      formationType: "formule",
      twoActions: false,
      threeActions: false,
      fourActions: false,
      weekendActions: false,
      otherActions: false,
      filteredProducts: null,
      periodCaptions: [],
      refreshKey: 0,
      typeCourseUnit: 2900019,
      typeCourseFormule: 2900012,
      typeFormuleOther: 7000,
      typeFormuleThreeStage: 7001,
      typeFormuleFourStage: 7002,
      typeFormuleWeekend: 7003,
      typeFormuleTwoStage: 7004,
      typeFormulePlusStage: 80001,
      formuleType: null,
      selectedTypeFormule: null,
      selectedProduct: null,
    };
  },
  mounted() {
    this.filteredFormuleType();
  },
  computed: {
    checkActionsProducts() {
      if (this.products.length > 0) {
        return this.products.filter((product) => {
          return product.actions.length > 0;
        }).length;
      } else {
        return 0;
      }
    },

    hasProductsMultipleTypeIds() {
      const productArray = Object.values(this.products);

      const hasValidFormuleProduct = productArray.some(
        (product) =>
          product.type_id == this.typeCourseFormule &&
          product.formule_type != this.typeFormulePlusStage &&
          product.actions.some(
            (action) =>
              action.type_id != this.typeCourseUnit &&
              !action.invisible_inscription_form
          )
      );

      if (!hasValidFormuleProduct) {
        return false;
      }

      const hasOtherValidProduct = productArray.some(
        (product) =>
          (product.type_id != this.typeCourseFormule ||
            (product.type_id == this.typeCourseFormule &&
              product.formule_type == this.typeFormulePlusStage)) &&
          product.actions.some(
            (action) =>
              action.type_id != this.typeCourseUnit &&
              !action.invisible_inscription_form
          )
      );

      return hasOtherValidProduct;
    },

    showInscriptionCard() {
      if (this.checkActionsProducts != 0 && this.hasProductsMultipleTypeIds) {
        if (this.selectedTypeFormule && this.selectedTypeFormule.length > 0) {
          return true;
        }

        return false;
      }

      if (this.selectedTypeFormule?.length == 0) {
        return false;
      }

      return true;
    },
  },

  methods: {
    filterProducts() {
      if (!this.hasProductsMultipleTypeIds) {
        const products = this.products;
        this.filteredProducts = this.sortFilterProductsByPrice(products);
      } else {
        this.filteredProducts = this.products;
      }

      this.refreshKey++;
      this.sortFilterProducts();

      if (this.selectedYear) {
        this.filteredProducts = this.filteredProducts.filter((product) => {
          return product.actions.some(
            (action) => action.year_id === this.selectedYear
          );
        });
      }

      if (this.selectedTypeFormule && this.selectedTypeFormule.length > 0) {
        this.filteredProducts = this.filteredProducts.filter((product) =>
          this.selectedTypeFormule.includes(product.formule_type)
        );
      }
    },

    formuleHasType(formuleType) {
      const productArray = Object.values(this.products);
      for (const product of productArray) {
        if (
          product.type_id == this.typeCourseFormule &&
          formuleType == product.formule_type
        ) {
          const hasValidAction = product.actions.some(
            (action) =>
              action.type_id !== this.typeCourseUnit &&
              !action.invisible_inscription_form
          );
          if (hasValidAction) {
            return true;
          }
        }
      }
      return false;
    },

    getActionPeriods() {
      this.$store.dispatch("getActionPeriods").then((response) => {
        this.periodCaptions = response;
      });
    },

    sortFilterProductsByPrice(products) {
      return products.sort((a, b) => {
        const getTarif = (product) => {
          const auto1Price = product.prices.find(
            (p) => p.typeTarif === "AUTO1"
          );
          return auto1Price
            ? auto1Price.amount_ttc
            : product.prices.find((p) => p.typeTarif === "1MAT")?.amount_ttc ||
                1;
        };

        const tarifA = getTarif(a);
        const tarifB = getTarif(b);

        return tarifB - tarifA;
      });
    },

    sortFilterProducts() {
      this.filteredProducts.sort((a, b) => {
        const aFirstPart = parseInt(a.internal_reference.split("-")[0]);
        const bFirstPart = parseInt(b.internal_reference.split("-")[0]);
        if (Number.isNaN(aFirstPart) || Number.isNaN(bFirstPart)) {
          if (Number.isNaN(aFirstPart)) return 1;
          if (Number.isNaN(bFirstPart)) return -1;
        }
        return aFirstPart - bFirstPart;
      });
    },

    filteredFormuleType() {
      let products = this.filteredProducts.filter(
        (item) => item.type_id != this.typeCourseUnit
      );
      products = products.filter((product) => {
        const actionsAvailable = Object.values(product.actions).filter(
          (action) => {
            return (
              action.type_id != this.typeCourseUnit &&
              !action.invisible_inscription_form
            );
          }
        );
        if (actionsAvailable.length > 0) {
          return true;
        }

        return false;
      });

      const list = [
        ...new Set(
          products
            .map((item) => item.formule_type)
            .filter((item) => item !== null)
        ),
      ];

      this.formuleType = list.map((item) => {
        return {
          title: getFormuleTypeLabel(item),
          value: item,
        };
      });
    },
  },

  created() {
    if (this.products.length > 0) {
      this.getActionPeriods();
      this.filterProducts();
    }
  },

  watch: {
    products(value) {
      if (value.length > 0) {
        this.filterProducts();
      } else {
        this.filteredProducts = null;
      }
    },

    formationType(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterProducts();
      }
    },

    twoActions(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterProducts();
      }
    },

    threeActions(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterProducts();
      }
    },

    fourActions(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterProducts();
      }
    },

    weekendActions(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterProducts();
      }
    },

    otherActions(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterProducts();
      }
    },

    selectedTypeFormule() {
      this.filterProducts();
    },
  },
};
</script>

<style scoped>
.phone-number {
  letter-spacing: -1px;
}

::v-deep .v-radio .v-label {
  opacity: 1 !important;
  color: #06113a !important;
}

.products {
  width: 100%;
}
</style>
